import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/workbench/image-chevron-down.svg")